import { Context, createContext, use } from "react";

import { ContextNotProvidedError } from "./context-not-provided-error";

export function createContextWithoutDefault<T>(): ContextWithoutDefault<T> {
  return createContext<T | undefined>(undefined);
}

export function useContextWithoutDefault<T>(
  context: ContextWithoutDefault<T>,
): T {
  const contextValue = use(context);
  if (contextValue === undefined)
    throw new ContextNotProvidedError(context.displayName);
  return contextValue;
}

export type ContextWithoutDefault<T> = Context<T | undefined>;
